export const BASE_URL =
process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PRODUCTION_SERVER
    : process.env.REACT_APP_DEVELOPMENT_SERVER;